import { AnyAction } from "@reduxjs/toolkit";

import { openCommunicationLinkAction } from "../actions";

export type ExternalResourcesStorePartState = {
  isGenerating: boolean;
};

export type ExternalResourcesStorePart = {
  externalResources: ExternalResourcesStorePartState;
};

const initialState: ExternalResourcesStorePartState = {
  isGenerating: false,
};

export function externalResourcesReducer(state = initialState, action: AnyAction): ExternalResourcesStorePartState {
  switch (true) {
    case openCommunicationLinkAction.started.match(action):
      return {
        ...state,
        isGenerating: true,
      };

    case openCommunicationLinkAction.done.match(action):
      return {
        ...state,
        isGenerating: false,
      };

    case openCommunicationLinkAction.failed.match(action):
      return {
        ...state,
        isGenerating: false,
      };

    default:
      return state;
  }
}
